import { tv, type VariantProps } from 'tailwind-variants'

import { Icon } from '@/components/atoms/Icon'

export const badgeVariants = tv({
  slots: {
    containerSlot:
      'font-body leading-default inline-flex items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-2xl border border-solid font-semibold',
    labelSlot: 'truncate',
    iconSlot: 'material-symbols-rounded flex-shrink-0'
  },
  variants: {
    variant: {
      canceled: {
        containerSlot:
          'bg-badge-canceled-bg border-badge-canceled-stroke text-badge-canceled-text'
      },
      danger: {
        containerSlot:
          'bg-badge-danger-bg border-badge-danger-stroke text-badge-danger-text'
      },
      'danger-light': {
        containerSlot:
          'bg-badge-danger-light-bg border-badge-danger-light-stroke text-badge-danger-light-text'
      },
      'danger-soft': {
        containerSlot:
          'bg-badge-danger-soft-bg border-badge-danger-soft-stroke text-badge-danger-soft-text'
      },
      fill: {
        containerSlot:
          'bg-badge-fill-bg border-badge-fill-stroke text-badge-fill-text'
      },
      info: {
        containerSlot:
          'bg-badge-info-bg border-badge-info-stroke text-badge-info-text'
      },
      open: {
        containerSlot:
          'bg-badge-open-bg border-badge-open-stroke text-badge-open-text'
      },
      outline: {
        containerSlot:
          'bg-badge-outline-bg border-badge-outline-stroke text-badge-outline-text'
      },
      success: {
        containerSlot:
          'bg-badge-success-bg border-badge-success-stroke text-badge-success-text'
      },
      warning: {
        containerSlot:
          'bg-badge-warning-bg border-badge-warning-stroke text-badge-warning-text'
      }
    },
    size: {
      md: {
        containerSlot:
          'text-caption-lg h-6 min-w-[88px] px-2 py-1 leading-[18px]',
        iconSlot: 'text-body-lg'
      },
      sm: {
        containerSlot:
          'text-caption-sm h-4 w-[72px] rounded-lg px-2 py-1 font-bold leading-[15px]',
        iconSlot: 'text-caption-lg'
      }
    }
  },
  defaultVariants: {
    variant: 'fill',
    size: 'md'
  }
})

export type TBadgeProps = VariantProps<typeof badgeVariants> & {
  icon?: string
  label: string
  maxWidth?: string
  className?: string
}

/**
 * @deprecated Use `Badge` from `@alternative/acqua/atoms` instead. The acqua-ui Badge is being phased out in favor of the acqua design system.
 */
export const Badge = ({
  icon,
  label,
  size,
  variant,
  maxWidth,
  className
}: TBadgeProps): JSX.Element => {
  const { containerSlot, labelSlot } = badgeVariants({
    variant,
    size
  })

  return (
    <div
      className={containerSlot({ className })}
      style={maxWidth ? { maxWidth } : undefined}
      title={label}
    >
      {icon && <Icon name={icon} size='md' />}
      <span className={labelSlot()}>{label}</span>
    </div>
  )
}
